import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonModule, NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    RouterLink,
    NgOptimizedImage,
    CommonModule
  ],
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  public name = environment.name;

  public appLogoPath: string = environment.appLogoBottomUrl;

  public showFooterEULogotypes = environment.showFooterEULogotypes;

  public version = environment.appVersion;
}
